// removed by extract-text-webpack-plugin
module.exports = {"root":"SectionContainer__root--3Lflx","header":"SectionContainer__header--2SXVe","bounce":"SectionContainer__bounce--2T4oE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/SectionContainer/SectionContainer.css
// module id = ./src/components/Library/SectionContainer/SectionContainer.css
// module chunks = 1